export const Storage = {
    basketReference: 'fog~basketReference',
    basketTimer: 'fog~basketTimer',
    freightType: 'fog~freightType',
    postalCode: 'fog~postalCode',
    warehouseId: 'fog~warehouseId',
    activeCustomerId: 'fog~activeCustomerId',
};
